module.exports = __webpack_public_path__ + "static/media/dark-logo.4e9eb566.png";